import cc from "classcat"
import { motion } from "framer-motion"

const variants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 },
    },
  },
  hidden: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 },
    },
  },
}

export const SectionItem = ({
  title,
  id,
  color,
  className = "",
  uppercase = true,
  size = "sm",
}) => (
  <motion.li
    className={cc([
      "mb-5 flex cursor-pointer list-none items-center justify-center rounded-xl border-2 border-solid p-1",
      color === "persona-color-1" && "border-persona-color-1",
      color === "persona-color-2" && "border-persona-color-2",
      color === "persona-color-3" && "border-persona-color-3",
      color === "persona-color-4" && "border-persona-color-4",
      {
        "border-accentColorHover": color === "accentColorHover",
        "border-zinc-800 bg-zinc-800 font-bold text-kkm-lightgreen":
          color === "dark",
        "border-kkm-red bg-kkm-red font-bold text-gray-50": color === "red",
        "border-gray-50 bg-gray-50 font-bold text-zinc-800": color === "light",
      },
      className,
    ])}
    variants={variants}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.95 }}
  >
    <a href={`#${id}`}>
      <div
        className={cc([
          "p-[0.8em] px-4 text-center",
          {
            uppercase: uppercase,
            "text-sm": size === "sm",
            "text-md": size === "md",
            "text-lg": size === "lg",
          },
        ])}
      >
        {title}
      </div>
    </a>
  </motion.li>
)
